import {
  ApplicationRelations,
  ApplicationType,
  DataSourceType,
  SourceApplication,
} from "../model";

export const SourceApplicationsDescriptors: Record<
  ApplicationType,
  SourceApplication
> = {
  confluence: {
    id: "confluence",
    sources: ["confluence"],
    name: "Confluence",
    icon: "Confluence",
    desc: "",
  },
  dropbox_storage: {
    id: "dropbox_storage",
    sources: ["dropbox_storage"],
    name: "Dropbox",
    icon: "DropBox",
    desc: "",
  },
  az_file_share: {
    id: "az_file_share",
    sources: ["az_file_share"],
    name: "Azure File Share",
    icon: "AzureSimple",
    desc: "",
  },
  az_ad_log: {
    id: "az_ad_log",
    sources: ["az_ad_log"],
    name: "AD Log",
    icon: "AzureSimple",
    desc: "",
  },
  mssql_db: {
    id: "mssql_db",
    sources: ["mssql_db"],
    name: "Microsoft SQL Server",
    icon: "Ms",
    desc: "",
  },
  snowflake: {
    id: "snowflake",
    sources: ["snowflake"],
    name: "Snowflake",
    icon: "Snowflake",
    desc: "",
  },
  az_resource_log: {
    id: "az_resource_log",
    sources: ["az_resource_log"],
    name: "Resource Log",
    icon: "AzureSimple",
    desc: "",
  },
  aws_logs: {
    id: "aws_logs",
    sources: ["aws_logs"],
    name: "Logs",
    icon: "AWS",
    desc: "",
  },
  cloud_mongo_db: {
    id: "cloud_mongo_db",
    sources: ["cloud_mongo_db"],
    name: "Mongo DB",
    icon: "Mongo",
    desc: "",
  },
  exchange365: {
    id: "exchange365",
    sources: ["motion_365"],
    name: "Exchange 365",
    icon: "Exchange",
    desc: "",
  },
  github: {
    id: "github",
    sources: ["github"],
    name: "Github",
    icon: "Github",
    desc: "",
  },
  google_workspace: {
    id: "google_workspace",
    sources: ["google_workspace"],
    name: "Workspace",
    icon: "Google",
    desc: "",
  },
  mip: {
    id: "mip",
    sources: ["motion_365"],
    name: "Ms",
    icon: "Teams",
    desc: "",
  },
  msft365: {
    id: "msft365",
    sources: ["msft_365", "motion_365"],
    name: "M365",
    icon: "MsColor",
    desc: "",
  },
  msft_admin: {
    id: "msft_admin",
    sources: ["msft_365"],
    name: "Admin",
    icon: "Ms",
    desc: "",
  },
  msft_dynamics_sales: {
    id: "msft_dynamics_sales",
    sources: ["msft_dynamics"],
    name: "Dynamics",
    icon: "MS-DynamicsColor",
    desc: "",
  },
  msft_onedrive: {
    id: "msft_onedrive",
    sources: ["motion_365", "msft_365"],
    name: "Onedrive",
    icon: "OneDrive",
    desc: "",
  },
  msft_sharepoint_365: {
    id: "msft_sharepoint_365",
    sources: ["msft_365", "motion_365"],
    name: "Sharepoint 365",
    icon: "SharePoint",
    desc: "",
  },
  msft_teams: {
    id: "msft_teams",
    sources: ["motion_365", "msft_365"],
    name: "Teams",
    icon: "Teams",
    desc: "",
  },
  oracle_cloud_app: {
    id: "oracle_cloud_app",
    sources: ["oracle_cloud_apps"],
    name: "Cloud App",
    icon: "Oracle",
    desc: "",
  },
  onprem_db: {
    id: "onprem_db",
    sources: ["onprem_db"],
    name: "Onprem DB",
    icon: "OnPrem",
    desc: "",
  },
  network_file_system: {
    id: "network_file_system",
    sources: ["onprem_fs"],
    name: "Onprem FS",
    icon: "OnPrem",
    desc: "",
  },
  power_bi: {
    id: "power_bi",
    sources: ["msft_365"],
    name: "PowerBi",
    icon: "Ms",
    desc: "",
  },
  salesforce: {
    id: "salesforce",
    sources: ["salesforce"],
    name: "SalesForce",
    icon: "SalesForce",
    desc: "",
  },
  amazon_s3: {
    id: "amazon_s3",
    sources: ["amazon_s3"],
    name: "S3",
    icon: "S3",
    desc: "",
  },
  az_storage: {
    id: "az_storage",
    sources: ["az_storage"],
    name: "Storage",
    icon: "AzureSimple",
    desc: "",
  },
  az_sql_db: {
    id: "az_sql_db",
    sources: ["az_sql_db"],
    name: "SQL DB",
    icon: "AzureSimple",
    desc: "",
  },
  az_cosmos_db: {
    id: "az_cosmos_db",
    sources: ["az_cosmos_db"],
    name: "CosmosDB",
    icon: "AzureSimple",
    desc: "",
  },

  amazon_doc_db: {
    id: "amazon_doc_db",
    sources: ["amazon_doc_db"],
    name: "DocDb",
    icon: "S3",
    desc: "",
  },
  msft_stream: {
    id: "msft_stream",
    sources: ["msft_dynamics"],
    name: "Stream",
    icon: "Ms",
    desc: "",
  },
  hub_spot: {
    id: "hub_spot",
    sources: ["hub_spot"],
    name: "HubSpot",
    icon: "HubSpotColor",
    desc: "",
  },
};

export const APPLICATIONS_MAP: Record<ApplicationType, ApplicationRelations> = {
  confluence: {
    security_posture_groups: ["CloudApp"],
    security_postures: [],
    sources: ["confluence"],
    application: "confluence",
    display_name: "Confluence",
  },
  dropbox_storage: {
    security_posture_groups: ["AtRest"],
    security_postures: [],
    sources: ["dropbox_storage"],
    application: "dropbox_storage",
    display_name: "Dropbox",
  },
  az_file_share: {
    security_posture_groups: ["AtRest"],
    security_postures: [],
    sources: ["az_file_share"],
    application: "az_file_share",
    display_name: "Azure file share",
  },
  az_ad_log: {
    security_posture_groups: ["CloudApp"],
    security_postures: [],
    sources: ["az_ad_log"],
    application: "az_ad_log",
    display_name: "Azure active directory log",
  },
  mssql_db: {
    security_posture_groups: ["AtRest"],
    security_postures: [],
    sources: ["mssql_db"],
    application: "mssql_db",
    display_name: "Microsoft Sql Server",
  },
  az_resource_log: {
    security_posture_groups: ["CloudApp"],
    security_postures: [],
    application: "az_resource_log",
    sources: ["az_resource_log"],
    display_name: "Azure resource log",
  },
  snowflake: {
    security_posture_groups: ["CloudApp"],
    security_postures: [],
    application: "snowflake",
    sources: ["snowflake"],
    display_name: "Snowflake",
  },
  aws_logs: {
    security_posture_groups: ["CloudApp"],
    security_postures: [],
    application: "aws_logs",
    sources: ["aws_logs"],
    display_name: "AWS Logs",
  },
  cloud_mongo_db: {
    security_posture_groups: ["AtRest"],
    security_postures: ["data_security"],
    application: "cloud_mongo_db",
    sources: ["cloud_mongo_db"],
    display_name: "Cloud mongo db",
  },
  exchange365: {
    security_posture_groups: ["InMotion"],
    security_postures: ["msgs"],
    application: "exchange365",
    sources: ["motion_365"],
    display_name: "Exchange 365",
  },
  github: {
    security_posture_groups: ["CloudApp"],
    security_postures: [], //"activities"
    application: "github",
    sources: ["github"],
    display_name: "Github",
  },
  google_workspace: {
    security_posture_groups: ["CloudApp"],
    security_postures: [], // "activities"
    application: "google_workspace",
    sources: ["google_workspace"],
    display_name: "Google Workspace",
  },
  mip: {
    security_posture_groups: ["CloudApp"],
    security_postures: [], // "activities"
    application: "mip",
    sources: ["motion_365"],
    display_name: "Microsoft Labeling",
  },
  msft365: {
    security_posture_groups: ["CloudApp"],
    security_postures: ["identities"],
    application: "msft365",
    sources: ["msft_365", "motion_365"],
    display_name: "Microsoft 365",
  },
  msft_admin: {
    security_posture_groups: ["CloudApp"],
    security_postures: [], // "activities"
    application: "msft_admin",
    sources: ["msft_365"],
    display_name: "Microsoft Admin",
  },
  msft_dynamics_sales: {
    security_posture_groups: ["CloudApp"],
    security_postures: ["activities"],
    application: "msft_dynamics_sales",
    sources: ["msft_dynamics"],
    display_name: "Microsoft Dynamics, Sales",
  },
  msft_onedrive: {
    security_posture_groups: ["AtRest", "InMotion"],
    security_postures: ["data_protection", "info_governance", "dlp"],
    application: "msft_onedrive",
    sources: ["motion_365", "msft_365"],
    display_name: "OneDrive",
  },
  msft_sharepoint_365: {
    security_posture_groups: ["AtRest", "InMotion"],
    security_postures: ["data_protection", "info_governance", "dlp"],
    application: "msft_sharepoint_365",
    sources: ["msft_365", "motion_365"],
    display_name: "Sharepoint 365",
  },
  msft_teams: {
    security_posture_groups: ["AtRest", "InMotion"],
    security_postures: ["data_protection", "info_governance", "dlp"],
    application: "msft_teams",
    sources: ["motion_365", "msft_365"],
    display_name: "Microsoft Teams",
  },
  oracle_cloud_app: {
    security_posture_groups: ["CloudApp"],
    security_postures: [], // "activities"
    application: "oracle_cloud_app",
    sources: ["oracle_cloud_apps"],
    display_name: "Oracle Cloud App",
  },
  onprem_db: {
    security_posture_groups: ["CloudApp"],
    security_postures: ["data_security"],
    application: "onprem_db",
    sources: ["onprem_db"],
    display_name: "Onprem db",
  },
  network_file_system: {
    security_posture_groups: ["AtRest"],
    security_postures: ["data_protection"],
    application: "network_file_system",
    sources: ["onprem_fs"],
    display_name: "Onprem fs",
  },
  power_bi: {
    security_posture_groups: ["CloudApp"],
    security_postures: [], // "activities"
    application: "power_bi",
    sources: ["msft_365"],
    display_name: "Power BI",
  },
  salesforce: {
    security_posture_groups: ["CloudApp"],
    security_postures: [], // "activities"
    application: "salesforce",
    sources: ["salesforce"],
    display_name: "SalesForce",
  },
  az_storage: {
    security_posture_groups: ["AtRest"],
    security_postures: ["data_security"],
    application: "az_storage",
    sources: ["az_storage"],
    display_name: "Azure Storage",
  },
  az_sql_db: {
    security_posture_groups: ["AtRest"],
    security_postures: ["data_security"],
    application: "az_sql_db",
    sources: ["az_sql_db"],
    display_name: "Azure SQL db",
  },
  az_cosmos_db: {
    security_posture_groups: ["AtRest"],
    security_postures: ["data_security"],
    application: "az_cosmos_db",
    sources: ["az_cosmos_db"],
    display_name: "Azure Cosmos db",
  },
  amazon_s3: {
    security_posture_groups: ["AtRest"],
    security_postures: ["data_security"],
    application: "amazon_s3",
    sources: ["amazon_s3"],
    display_name: "S3",
  },
  amazon_doc_db: {
    security_posture_groups: ["AtRest"],
    security_postures: ["data_security"],
    application: "amazon_doc_db",
    sources: ["amazon_doc_db"],
    display_name: "Amazon Doc db",
  },
  msft_stream: {
    security_posture_groups: ["CloudApp"],
    security_postures: [], // "activities"
    application: "msft_stream",
    sources: ["msft_dynamics"],
    display_name: "Microsoft Stream",
  },
  hub_spot: {
    security_posture_groups: ["CloudApp"],
    security_postures: [], // "activities"
    application: "hub_spot",
    sources: ["hub_spot"],
    display_name: "HubSpot",
  },
};

// @ts-ignore
export const SOURCE_TO_APPS_MAP: Record<DataSourceType, ApplicationType[]> = {
  az_ad_log: ["az_ad_log"],
  az_resource_log: ["az_resource_log"],
  aws_logs: ["aws_logs"],
  cloud_mongo_db: ["cloud_mongo_db"],
  motion_365: [
    "exchange365",
    "mip",
    "msft365",
    "msft_onedrive",
    "msft_teams",
    "power_bi",
    "msft_sharepoint_365",
  ],
  github: ["github"],
  google_workspace: ["google_workspace"],
  msft_365: [
    "msft365",
    // "msft_admin",
    "msft_sharepoint_365",
    "msft_onedrive",
    "msft_teams",
  ],
  msft_dynamics: ["msft_dynamics_sales"],
  oracle_cloud_apps: ["oracle_cloud_app"],
  onprem_db: ["onprem_db"],
  onprem_fs: ["network_file_system"],
  salesforce: ["salesforce"],
  az_storage: ["az_storage"],
  az_sql_db: ["az_sql_db"],
  az_cosmos_db: ["az_cosmos_db"],
  amazon_s3: ["amazon_s3"],
  amazon_doc_db: ["amazon_doc_db"],
  hub_spot: ["hub_spot"],
};
